// const base_url = 'https://muscle-wiki-be.technottix.com';
const base_url = "https://admin.workoutlibrary.org";
// const base_url = 'http://muscle-wiki-be.test';
const imagesExtention = ["jpeg", "jpg", "png", "gif"];

export { base_url, imagesExtention };

// https://admin.workoutlibrary.org/api/sign-up-new
